module.exports = __webpack_public_path__ + "img/icon_user.7b6d637d.png";